import { Play } from "lucide-react";
import Reveal from "./Reveal";
import SectionHeading from "./SectionHeading";
import ArtFrame from "./ArtFrame";

const Trailer = () => (
  <section id="trailer" data-testid="trailer-section" className="relative z-10 px-6 py-28 md:px-16 lg:px-24 lg:py-40">
    <SectionHeading
      title="TRAILER"
      eyebrow="The universe, in motion. The official Cosmic Dreams trailer arrives here first."
    />
    <Reveal>
      <ArtFrame
        image=""
        hue="veil"
        ratio="aspect-video"
        label=""
        veil
        className="mx-auto max-w-4xl border border-white/10 shadow-[0_30px_80px_rgba(0,0,0,0.7)]"
      >
        <div className="absolute inset-0 flex flex-col items-center justify-center gap-5">
          <span className="flex h-16 w-16 items-center justify-center rounded-full border border-white/20 bg-black/40 backdrop-blur-sm">
            <Play size={20} strokeWidth={1.25} className="ml-1 text-white/70" />
          </span>
          <span className="font-mono text-[10px] tracking-[0.4em] text-[#A0A0B0] uppercase">Official trailer</span>
          <span className="font-tech text-[9px] uppercase text-[#D4AF37]">Coming soon</span>
        </div>
      </ArtFrame>
    </Reveal>
  </section>
);

export default Trailer;
